var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbsurdUni(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 415.2",
    style: {
      enableBackground: "new 0 0 600 415.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E9B420;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#F8CA7C;}\n\t.st3{fill:#F37048;}\n\t.st4{fill:#EF4136;}\n\t.st5{fill:#7F3F98;}\n\t.st6{fill:#F06287;}\n\t.st7{fill:#F9D18D;}\n\t.st8{fill:#F0494A;}\n\t.st9{fill:#706BB1;}\n\t.st10{fill:#B4B0D7;}\n\t.st11{fill:#A19BCC;}\n\t.st12{fill:none;stroke:#7F3F98;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#706BB1;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#F0494A;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#F37048;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#F8CA7C;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:none;}\n\t.st19{fill:url(#SVGID_1_);}\n\t.st20{fill:#F15A29;}\n\t.st21{fill:#DA1C5C;}\n\t.st22{fill:url(#SVGID_00000031183155564691561980000015345883822826694314_);}\n\t.st23{fill:#9E1F63;}\n\t.st24{fill:url(#SVGID_00000157296777876575563400000018391320501150604935_);}\n\t.st25{fill:#662D91;}\n\t.st26{fill:url(#SVGID_00000018927416083950862400000006869636453069108109_);}\n\t.st27{fill:url(#SVGID_00000178203751990830060620000008249835057751995012_);}\n\t.st28{fill:#D7DF23;}\n\t.st29{fill:#F7941D;}\n\t.st30{fill:#F8CA7C;stroke:#F8CA7C;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st31{fill:#92278F;}\n\t.st32{fill:#262262;}\n\t.st33{fill:#F1F2F2;}\n\t.st34{opacity:0.67;fill:#FFFFFF;}\n\t.st35{fill:#7771B4;}\n\t.st36{fill:#8F3F98;}\n\t.st37{fill:#B7D65E;}\n\t.st38{fill:#EE3775;}\n\t.st39{fill:#222428;}\n\t.st40{fill:#E0AC25;}\n\t.st41{opacity:0.67;fill:#F8CA7C;}\n\t.st42{fill:#BF9D2E;}\n\t.st43{fill:#D7A728;}\n\t.st44{fill:#EAA922;}\n\t.st45{stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st46{fill:#7F3F98;stroke:#7F3F98;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st47{opacity:0.5;fill:#FFFFFF;}\n\t.st48{fill:none;stroke:#7F3F98;stroke-width:6.0055;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st49{fill:none;stroke:#F0494A;stroke-width:6.0055;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st50{fill:none;stroke:#EE3775;stroke-width:6.0055;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st51{fill:none;stroke:#F37048;stroke-width:6.0055;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st52{fill:none;stroke:#F8CA7C;stroke-width:6.0055;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st53{fill:#F8CA7C;stroke:#F8CA7C;stroke-width:6.0055;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st54{opacity:0.68;}\n\t.st55{fill:none;stroke:#E9B420;stroke-miterlimit:10;}\n\t.st56{fill:none;stroke:#1E2123;stroke-width:6.0055;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st57{fill:#1E2123;stroke:#1E2123;stroke-width:6.0055;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st58{fill:none;stroke:#F8CA7C;stroke-width:5.1743;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st59{fill:#1E2123;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M312,113.4c-128.4,61.5-232.9,166-232.9,232.9S183.6,423,312,367.9c128.5-55,233-159.5,233-232.9 C544.9,61.6,440.4,51.9,312,113.4z M312,135.1c106.3-50.4,192.8-42.5,193.2,17.5c0,0.1,0,0.3,0,0.4c0,60.4-86.7,147.1-193.3,193.3 c-106.6,46.1-193.2,38.1-193.2-18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M505.2,152.6c-0.4-60-86.9-67.9-193.2-17.5c-106.3,50.4-192.8,136.8-193.2,192.9v0.4c0,56,86.7,64.1,193.2,18 C418.6,300.1,505.3,213.4,505.3,153C505.3,152.9,505.3,152.7,505.2,152.6z M380.7,284.6c-0.5,0.4-1,0.7-1.5,1.1 c-17.3,12.3-36.4,23.6-56.5,33.1c-1.4,0.7-2.7,1.3-4.1,1.9c-2.2,1-4.3,1.9-6.5,2.9c-84.7,36.7-153.6,30.3-153.6-14.3 c0-0.2,0-0.3,0-0.5c0.3-30.3,32.1-71.6,78.8-107.5c2.5-2,5.1-3.9,7.8-5.8c19-13.9,40.3-26.8,62.7-37.7c1.4-0.7,2.8-1.4,4.3-2 c0.7-0.4,1.5-0.7,2.2-1c83.4-38.8,150.9-32.3,151.4,14.8c0,0.2,0,0.3,0,0.5C465.6,204,431,248.4,380.7,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M465.5,169.5c-0.5-47.1-68-53.6-151.4-14.8c-0.7,0.3-1.5,0.7-2.2,1c-1.4,0.7-2.8,1.3-4.3,2 c-22.4,10.9-43.7,23.9-62.7,37.7c-2.6,1.9-5.2,3.9-7.8,5.8c-46.8,35.9-78.5,77.2-78.8,107.5c0,0.2,0,0.3,0,0.5 c0,44.6,68.9,51,153.6,14.3c2.2-1,4.3-1.9,6.5-2.9c1.4-0.6,2.8-1.3,4.1-1.9c20.2-9.5,39.3-20.8,56.5-33.1c0.5-0.4,1-0.7,1.5-1.1 C431,248.4,465.6,204,465.6,170C465.6,169.8,465.6,169.6,465.5,169.5z M394.8,244.6c-0.2,0.3-0.5,0.5-0.7,0.8 c-20.7,21.2-49.9,41.5-82.1,55.5c-10.9,4.7-21.5,8.5-31.4,11.3c-1.2,0.3-2.4,0.7-3.6,1c-45.7,12.1-78.9,3.8-78.9-22.9 c0-0.1,0-0.2,0-0.4c0,0,0-0.1,0-0.1c0.2-15.8,11.9-35.6,30.8-55.1c1.3-1.4,2.8-2.8,4.2-4.2c20.5-20.1,48.3-39.6,78.9-54 c11.3-5.4,22.3-9.6,32.6-12.7c1.1-0.3,2.2-0.7,3.3-1c45-12.8,77.6-4.3,78,23.7c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.4 C425.9,204.1,414.1,224.7,394.8,244.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M425.9,186.6c0,0,0-0.1,0-0.1c-0.4-28-33-36.5-78-23.7c-1.1,0.3-2.2,0.6-3.3,1c-10.3,3.1-21.3,7.3-32.6,12.7 c-30.6,14.4-58.4,34-78.9,54c-1.4,1.4-2.8,2.8-4.2,4.2c-18.9,19.6-30.6,39.4-30.8,55.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.4 c0,26.7,33.2,35,78.9,22.9c1.2-0.3,2.4-0.6,3.6-1c10-2.8,20.5-6.6,31.4-11.3c32.2-14,61.4-34.3,82.1-55.5c0.2-0.3,0.5-0.5,0.7-0.8 c19.2-19.9,31-40.5,31-57.6C425.9,186.9,425.9,186.7,425.9,186.6z M386.2,202.8C386.2,202.9,386.2,202.9,386.2,202.8v0.2 c0,0.2,0,0.4,0,0.7c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2c0,23.1-33.2,56.3-74.2,74.2c-26.5,11.6-49.7,14.4-62.8,9.1 c-3-1.2-5.5-2.9-7.3-4.9c-1.4-1.5-2.5-3.4-3.2-5.4c-0.6-1.7-0.9-3.6-0.9-5.7c0-0.2,0-0.4,0-0.5c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.4 c0-1,0.1-2,0.2-3.1c0,0,0,0,0,0c2.9-21.4,34.9-52.4,74-71.1c26.7-12.8,50.1-15.9,63.2-10.1c1.2,0.5,2.3,1.1,3.3,1.8 c0.8,1,1.6,2.1,2.3,3.2c0.5,0.8,1.1,1.5,1.5,2.3c0.2,0.2,0.3,0.4,0.4,0.7c0.5,0.8,1,1.6,1.4,2.4c0.2,0.4,0.5,0.8,0.7,1.2 c0.1,0.2,0.2,0.4,0.3,0.6C385.8,199.7,386.1,201.2,386.2,202.8L386.2,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M520.4,204.9c15.7-24.6,24.5-48.6,24.5-69.9c0-53.7-55.9-73.3-136.1-55.9 M202.1,180.3 C128.9,235.8,79.1,300,79.1,346.3c0,31,22.4,49.7,59.2,55.4 M312,135.1 M505.2,152.6c0,0.1,0,0.3,0,0.4 c0,60.4-86.7,147.1-193.3,193.3c-106.6,46.1-193.2,38.1-193.2-18v-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M453.1,102.9c-35.3-4.7-85.5,5.7-141.2,32.1 M118.7,328.3c0,33.7,31.3,50,79.4,47.7 c32-1.5,71.3-11.3,113.9-29.7C418.6,300.1,505.3,213.4,505.3,153 M465.5,169.5c0,0.2,0,0.3,0,0.5c0,34-34.6,78.4-84.9,114.6  M158.4,309.3c0-0.2,0-0.3,0-0.5c0.3-30.3,32.1-71.6,78.8-107.5c2.5-2,5.1-3.9,7.8-5.8c19-13.9,40.3-26.8,62.7-37.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M307.7,157.8c-22.4,10.9-43.7,23.9-62.7,37.7c-2.6,1.9-5.2,3.9-7.8,5.8c-46.8,35.9-78.5,77.2-78.8,107.5 c0,0.2,0,0.3,0,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M380.7,284.6C431,248.4,465.6,204,465.6,170c0-0.2,0-0.4,0-0.5c-0.2-16.2-8.2-27.6-22.2-34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M277,313.2c-45.7,12.1-78.9,3.8-78.9-22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M347.8,162.8c45-12.8,77.6-4.3,78,23.7c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.2,202.8L386.2,202.8c0,0.1,0,0.1,0,0.1v0.2c0,0.2,0,0.4,0,0.7c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2 c0,23.1-33.2,56.3-74.2,74.2c-26.5,11.6-49.7,14.4-62.8,9.1c-3-1.2-5.5-2.9-7.3-4.9c-1.1-1.7-2.2-3.5-3.2-5.4 c-0.6-1.7-0.9-3.6-0.9-5.7c0-0.2,0-0.4,0-0.5c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.4c0-1,0.1-2,0.2-3.1c0,0,0,0,0,0 c2.9-21.4,34.9-52.4,74-71.1c26.7-12.8,50.1-15.9,63.2-10.1c1.2,0.5,2.3,1.1,3.3,1.8c0.8,1,1.6,2.1,2.3,3.2 c0.5,0.8,1.1,1.5,1.5,2.3c0.2,0.2,0.3,0.4,0.4,0.7c0.5,0.8,1,1.6,1.4,2.4c0.2,0.4,0.5,0.8,0.7,1.3c0.1,0.2,0.2,0.4,0.3,0.6 C385.8,199.7,386.1,201.2,386.2,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M378.4,187.9c-1-0.7-2.1-1.3-3.3-1.8c-13.1-5.8-36.5-2.7-63.2,10.1c-39,18.7-71,49.7-74,71.1c0,0,0,0,0,0 c-0.1,1.1-0.2,2.1-0.2,3.1c0,0.1,0,0.2,0,0.4c0,0,0,0.1,0,0.1c0,0.2,0,0.4,0,0.5c0,2.1,0.3,4,0.9,5.7c-6.3-11.7-9.8-25-9.8-39.2 c0-1.1,0-2.1,0.1-3.1c0.4-11.9,3.4-23.2,8.3-33.3c13.5-27.6,41.9-46.7,74.7-46.7c0.7,0,1.4,0,2.2,0c12,0.3,23.4,3.2,33.7,8.1 C360,168.6,370.5,177.2,378.4,187.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 72.3,
    cy: 221,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 13.3,
    cy: 333.1,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 78.6,
    cy: 89.4,
    r: 11.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 105.8,
    cy: 176.2,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 70.1,
    cy: 316,
    r: 12.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st38",
    cx: 273.4,
    cy: 92.8,
    r: 15.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 194.8,
    cy: 145.6,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 219.7,
    cy: 377.8,
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 269,
    cy: 382.7,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 183.7,
    cy: 223.3,
    r: 10.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 153.6,
    cy: 209.3,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 342.8,
    cy: 133.1,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 348.3,
    cy: 259.6,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 458.2,
    cy: 218.4,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 385,
    cy: 336.9,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 387.8,
    cy: 55.6,
    r: 12.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 543.7,
    cy: 175.2,
    r: 12.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 383.4,
    cy: 253.7,
    r: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 517.1,
    cy: 285.5,
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 502.6,
    cy: 32.6,
    r: 18.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 589,
    cy: 69,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 476.5,
    cy: 107.5,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 536.7,
    cy: 349.8,
    r: 10.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st38",
    cx: 458.2,
    cy: 383.8,
    r: 6.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M527,275.8c-2.2-2.1-5.5,1.2-3.4,3.4c2.5,2.4,3.5,6,2.5,9.2c-0.9,3.1-3.5,5.5-6.6,6.3 c-3,0.8-1.7,5.3,1.3,4.6c4.7-1.2,8.6-4.9,10-9.6C532.1,284.8,530.6,279.3,527,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M267.2,398.7c-6.3-2-11-8.3-11-14.9c0-6.6,4.7-12.9,11-14.9c2.9-0.9,1.7-5.5-1.3-4.6 c-8.3,2.7-14.5,10.7-14.5,19.5c0,8.8,6.2,16.8,14.5,19.5C268.8,404.2,270.1,399.6,267.2,398.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M288.9,85.4c-2.9-6.6-10.1-10.9-17.2-10.6c-3,0.1-3.1,4.9,0,4.7c5.4-0.2,10.8,2.9,13,7.9 c2.2,4.9,0.9,10.9-2.8,14.7c-2.1,2.2,1.2,5.5,3.4,3.4C290.3,100.3,291.8,92.2,288.9,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M481.2,97c-4.3-1.9-9.2-1-12.8,2c-1,0.8-0.9,2.5,0,3.4c1,1,2.4,0.8,3.4,0c0,0,0.2-0.2,0.3-0.3 c0.1-0.1,0.3-0.2,0.3-0.2c0.3-0.2,0.7-0.4,1-0.6c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.2,0c0.2-0.1,0.4-0.1,0.6-0.2 c0.4-0.1,0.8-0.2,1.1-0.3c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.2,0,0.4,0,0.6,0c0.4,0,0.8,0,1.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0 c0.2,0,0.5,0.1,0.7,0.2c0.2,0,0.3,0.1,0.4,0.1c0,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.1,0.3,0.2,0.5,0.3 c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1,0.1c0.3,0.3,0.6,0.5,0.8,0.8c0.1,0.1,0.3,0.3,0.4,0.4c0,0.1,0.1,0.1,0.1,0c0,0,0,0,0.1,0.1 c0.2,0.3,0.4,0.6,0.6,1c0.1,0.2,0.2,0.4,0.3,0.5c0,0.1,0.1,0.2,0.1,0.3c0.1,0.4,0.2,0.7,0.3,1.1c0,0.1,0.1,0.3,0.1,0.4 c0,0,0,0.3,0,0.4c0.1,1.2,1,2.4,2.4,2.4c1.2-0.1,2.5-1,2.4-2.4C487.8,102.9,485.2,98.8,481.2,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M388.9,242c-1.1-0.5-2.6-0.3-3.2,0.9c-0.6,1.1-0.3,2.7,0.9,3.2c0.5,0.2,1,0.5,1.5,0.8 c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0,0,0,0c0.2,0.2,0.5,0.4,0.7,0.6c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0.1,0.1 c0,0,0,0,0,0c0.3,0.5,0.6,1,0.9,1.5c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0.1,0.1,0.1c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.1,0.7,0.2,1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0.2,0,0.3,0,0.5c0,0.7,0,1.3,0,1.9c0,0,0,0.1,0,0.1c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.3-0.2,0.7-0.3,1 c-0.4,1.2,0.5,2.6,1.7,2.9c1.3,0.3,2.5-0.4,2.9-1.7C397.7,251.8,394.8,244.8,388.9,242z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M229.4,369c-2.9-2.9-7.2-4.6-11.3-4.1c-4.2,0.5-7.9,2.8-10.2,6.3c-0.6,0.9-0.2,2.2,0.7,2.7 c1,0.6,2.1,0.2,2.7-0.7c3.5-5.2,10.9-5.8,15.3-1.4C228.4,373.6,231.2,370.8,229.4,369z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.8,311.8c-1.5-5.9-7.1-10.2-13.2-10.5c-2.6-0.1-2.5,3.8,0,4c4.3,0.2,8.3,3.4,9.3,7.5 c1,4-0.8,8.6-4.3,10.9c-2.1,1.4-0.1,4.8,2,3.4C83.7,323.9,86.3,317.6,84.8,311.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M345.3,128c-1.7-0.5-3.7-0.3-5.3,0.5c-1.5,0.8-2.6,2.2-3.1,3.8c-0.3,1,0.4,2.2,1.4,2.4 c1.1,0.2,2-0.3,2.4-1.3l0,0c0.1-0.3,0.3-0.5,0.5-0.8c0.2-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.5-0.1,0.7-0.2 c0.2,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.6,0.1c1,0.3,2.2-0.4,2.4-1.4C346.9,129.4,346.4,128.4,345.3,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M541.8,160.6c-5.5,0.4-10.1,3.8-12.2,8.8c-0.4,1,0.4,2.2,1.4,2.4c1.2,0.3,2-0.4,2.4-1.4c-0.2,0.5,0,0,0-0.1 c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.4-0.7c0.1-0.2,0.3-0.5,0.4-0.7c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0,0,0 c0.3-0.4,0.7-0.8,1.1-1.1c0.2-0.2,0.4-0.3,0.6-0.5c0,0,0,0,0,0c0.1-0.1,0.2-0.2,0.3-0.2c0.4-0.3,0.8-0.6,1.3-0.8 c0.2-0.1,0.5-0.3,0.7-0.4c0,0,0,0,0.1,0c0.1,0,0.3-0.1,0.3-0.1c0.5-0.2,1-0.3,1.5-0.4c0.2-0.1,0.5-0.1,0.7-0.1c0,0,0,0,0,0 c0,0,0,0,0.1,0c0.1,0,0.3,0,0.4,0c1-0.1,2-0.9,2-2C543.8,161.5,542.9,160.5,541.8,160.6z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsurdUni);
export default __webpack_public_path__ + "static/media/AbsurdUni.3b0421760e4ea899f3f31b07c6ca9227.svg";
export { ForwardRef as ReactComponent };